import { render } from "./vmImage.vue?vue&type=template&id=42a461ed"
import script from "./vmImage.vue?vue&type=script&lang=js"
export * from "./vmImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__